(() => {
  if (window.lbKlaviyoCollectionsStarted) return;
  window.lbKlaviyoCollectionsStarted = true;
  const configNode = document.getElementById('LBKlaviyoCollections');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const key = 'lbKlaviyoViewedSessionV1';
  const sessionGap = 30 * 60 * 1000;
  let views = [], lastView = 0, cart = null, lastSent = '', timer = 0, busy = false;
  let cartTimer = 0, reading = false, again = false, currentRecorded = false;
  const root = (config.root || '/').replace(/\/?$/, '/');
  function allowed() {
    try {
      const cp = window.Shopify && window.Shopify.customerPrivacy;
      const cb = window.Cookiebot;
      return !!(cp && cp.marketingAllowed() && cp.analyticsProcessingAllowed() &&
        cb && cb.hasResponse && cb.consent.marketing && cb.consent.statistics);
    } catch (_) { return false; }
  }
  function url(value, image = false) {
    try {
      const u = new URL(value, location.origin);
      if (u.protocol !== 'https:') return '';
      if (!image && u.origin !== location.origin) return '';
      if (image && !/(^|\.)shopify\.com$|(^|\.)shopifycdn\.com$/.test(u.hostname) && u.origin !== location.origin) return '';
      return u.href;
    } catch (_) { return ''; }
  }
  function item(value, isCart) {
    const id = String(value.product_id || value.id || '');
    if (!/^\d+$/.test(id)) return null;
    const quantity = isCart ? Number(value.quantity) : 1;
    if (!Number.isInteger(quantity) || quantity <= 0) return null;
    const image = value.image_url || value.featured_image?.url || value.image || '';
    return {
      product_id: id,
      variant_id: isCart ? String(value.variant_id || value.id || '') : '',
      title: String(value.product_title || value.title || '').slice(0, 300),
      variant: isCart && value.variant_title !== 'Default Title' ? String(value.variant_title || '').slice(0, 200) : '',
      quantity,
      image_url: url(image, true),
      url: url(value.url || ''),
      price: Number((Number(value.final_price ?? value.price ?? 0) / 100).toFixed(2)),
      line_price: Number((Number(value.final_line_price ?? value.line_price ?? value.price ?? 0) / 100).toFixed(2))
    };
  }
  function rememberCurrent() {
    if (currentRecorded || !config.product || !allowed()) return;
    currentRecorded = true;
    const now = Date.now();
    try {
      const saved = JSON.parse(localStorage.getItem(key) || 'null');
      if (saved && now - saved.at < sessionGap && Array.isArray(saved.items)) {
        views = saved.items.filter(v => v && /^\d+$/.test(v.product_id) && url(v.url));
      }
    } catch (_) {}
    const next = item(config.product, false);
    if (!next) return;
    views = views.filter(v => v.product_id !== next.product_id);
    views.push(next);
    lastView = now;
    try { localStorage.setItem(key, JSON.stringify({at: now, items: views})); } catch (_) {}
  }
  function captureCart(value) {
    if (!allowed() || !Array.isArray(value?.items)) return;
    const items = value.items.map(v => item(v, true)).filter(Boolean);
    if (items.length !== value.items.length) return;
    cart = {items, currency: value.currency || config.currency};
    schedule();
  }
  async function refreshCart() {
    if (!allowed()) return;
    if (reading) { again = true; return; }
    reading = true;
    try {
      const response = await fetch(root + 'cart.js', {credentials: 'same-origin', cache: 'no-store'});
      if (response.ok && allowed()) captureCart(await response.json());
    } catch (_) {}
    finally { reading = false; if (again) { again = false; queueCart(); } }
  }
  function queueCart() {
    if (!allowed()) return;
    clearTimeout(cartTimer);
    cartTimer = setTimeout(refreshCart, 250);
  }
  function properties() {
    const p = {LB_CollectionsVersion: 1};
    if (views.length) {
      p.LB_ViewedItems = views;
      p.LB_ViewedUpdatedAt = new Date(lastView).toISOString();
      p.LB_ViewedCurrency = config.currency;
    }
    if (cart) {
      p.LB_CartItems = cart.items;
      p.LB_CartHasItems = cart.items.length > 0;
      p.LB_CartCurrency = cart.currency;
    }
    return p;
  }
  async function flush() {
    if (busy || !allowed()) return;
    const k = window.klaviyo;
    if (!k || typeof k.isIdentified !== 'function' || typeof k.identify !== 'function') return;
    const p = properties(), signature = JSON.stringify(p);
    if (signature === lastSent || signature.length > 80000) return;
    busy = true;
    try {
      if (await k.isIdentified() && allowed()) {
        await k.identify(p);
        lastSent = signature;
      }
    } catch (_) {}
    finally { busy = false; }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(flush, 400); }
  function start() {
    if (!allowed()) {
      clearTimeout(timer); clearTimeout(cartTimer);
      views = []; cart = null; currentRecorded = false; lastSent = '';
      try { localStorage.removeItem(key); } catch (_) {}
      return;
    }
    rememberCurrent();
    queueCart();
    schedule();
  }
  ['CookiebotOnConsentReady', 'CookiebotOnAccept', 'CookiebotOnDecline'].forEach(name => window.addEventListener(name, start));
  document.addEventListener('visitorConsentCollected', start);
  ['cart:updated', 'cart:build', 'ajaxProduct:added', 'drawerOpen.CartDrawer'].forEach(name => document.addEventListener(name, queueCart));
  window.addEventListener('klaviyoForms', schedule);
  window.addEventListener('pageshow', start);
  window.addEventListener('focus', () => { queueCart(); schedule(); });
  window.addEventListener('storage', e => { if (e.key === key && allowed()) { try { const s = JSON.parse(e.newValue || 'null'); if (s && Array.isArray(s.items)) { views = s.items; lastView = s.at; schedule(); } } catch (_) {} } });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) start(); });
  try {
    new PerformanceObserver(list => {
      if (list.getEntries().some(e => { try { const u = new URL(e.name); return u.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname); } catch (_) { return false; } })) queueCart();
    }).observe({type: 'resource', buffered: false});
  } catch (_) {}
  setInterval(() => { if (!document.hidden && allowed()) schedule(); }, 15000);
  start();
})();
